
import { call, put, takeLatest } from 'redux-saga/effects';
import { InvitationPasswordActionType, confirmInvitationPasswordSuccess, confirmInvitationPasswordError } from './actions';
import { postTask } from '../../services';
import { Urls } from '../../config/urls';
import { handleErrorInfo } from '../../utils';


function* confirmInvitationPasswordSaga(action: any): any {
  try {
    const { response, error } = yield call(postTask, {
      url: Urls.api.confirmInvitationPassword,
      body: { password: action.password, token: action.token },
    });
    if (response) {
      yield put(confirmInvitationPasswordSuccess());
    } else {
      const errorInfo = handleErrorInfo(
        InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD_ERROR,
        error
      );
      yield put(confirmInvitationPasswordError(errorInfo));
    }
  } catch (err: any) {
    const errorInfo = handleErrorInfo(
      InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD_ERROR,
      err
    );
    yield put(confirmInvitationPasswordError(errorInfo));
  }
}

export function* invitationPasswordSaga() {
  yield takeLatest(InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD, confirmInvitationPasswordSaga);
}
